export default __webpack_public_path__ + "static/media/key-step3.7293e982.gif";